import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import styles from './styles'

const EndPiece = withStyles(styles)(props => {
  const { classes, published, author } = props
  return (
    <div className={classes.contents}>
      <div className={classes.endpiece}>
        <Grid container spacing={40}>
          <Grid item xs={12}>
            {author.name && (
              <Typography variant="caption" className={classes.author}>
                &copy; {author.name.text}
              </Typography>
            )}
            <Typography variant="caption" gutterBottom={true} className={classes.date}>
              {published}
            </Typography>
          </Grid>
        </Grid>
      </div>
    </div>
  )
})

export default withStyles(styles)(EndPiece)



// WEBPACK FOOTER //
// ./src/components/endpiece/index.js